import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
// import { Col, Row, Card, Image, Button, Container } from '@themesberg/react-bootstrap';
// import { Link } from 'react-router-dom';
// import { Routes } from "../../routes";
// import NotFoundImage from "../../assets/img/illustrations/404.svg";

export default function NotFoundPage() {
  const saveRef = useRef(null);
  const [saveModalOpen, setSaveModalOpen] = useState(true);
  const location = useLocation();

  // Reopen modal whenever the location changes
  useEffect(() => {
    setSaveModalOpen(true);
  }, [location]);

  const handleSaveConfirm = () => {
    setSaveModalOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (saveRef.current && !saveRef.current.contains(event.target)) {
        setSaveModalOpen(false);
      }
    }

    if (saveModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveModalOpen]);

  return (
    <main>
      {/* <section className="vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row>
            <Col xs={12} className="text-center d-flex align-items-center justify-content-center">
              <div>
                <Card.Link as={Link} to={Routes.DashboardOverview.path}>
                  <Image src={NotFoundImage} className="img-fluid w-75" />
                </Card.Link>
                <h1 className="text-primary mt-5">
                  Page not <span className="fw-bolder">found</span>
                </h1>
                <p className="lead my-4">
                  Oops! Looks like you followed a bad link. If you think this is a
                  problem with us, please tell us.
            </p>
                <Button as={Link} variant="primary" className="animate-hover" to={Routes.DashboardOverview.path}>
                  <FontAwesomeIcon icon={faChevronLeft} className="animate-left-3 me-3 ms-2" />
                  Go back home
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      {saveModalOpen && (
        <>
          <div className="drawer-overlay" />
          <div
            className="entity-drawer modal-popup-cls"
            ref={saveRef}
            style={{
              maxWidth: 650,
              margin: "0 auto",
              background: "white",
              borderRadius: 12,
              zIndex: 1050,
              padding: 24,
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
              height: "auto",
              right: "auto",
              overflow: "inherit",
            }}
          >
            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
              <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                <X size={20} />
              </button>
            </div>
            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>
              New feature in Progress
            </h3>
            <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
              Work in Progress
            </p>
            <div className="drawer-footer" style={{ paddingTop: "10px" }}>
              <button className="btn-save" onClick={handleSaveConfirm}>
                OK
              </button>
            </div>
          </div>
        </>
      )}
    </main>
  );
}
